import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';


@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  public labels: any;
  public relationList: any = [];
  public languageList: any;
  constructor(private user: UserService) {
    this.loadLabels();
    this.user.languageChangeSubject.subscribe(() => this.loadLabels());
    this.user.getMasterConfig.subscribe(data => {
      if(data && data['list']) {
        this.relationList = data.list.filter(d => {
          return d.domain === 'RELATIONSHIP_TYPE'
        })[0]['codes'];
      }
    });
    this.user.getLanguages().subscribe(data => {
      this.languageList = data;
    });

  }

  private loadLabels(): void {
    const cached = this.user.getLocaleLabels();
    if (cached) {
      this.labels = cached;
    }
    this.user.getLabels().subscribe(data => {
      this.labels = data;
    });
  }

  transform(value: any, type: string = 'LABELS', key?: string, lang?: string, replace?: any, returnNull?: boolean, defaultValue: string = '', fallback?): any {
    if(lang) {
      this.labels = this.user.getLocaleLabels();
    }
    if (!this.labels) {
      this.labels = this.user.getLocaleLabels();
    }
    if (type === 'FACTIMEZONE') {
      let facilityId = key; key = null;
      type = 'LABELS'

      let facKey = `${key}_${facilityId}`;
      if (this.labels && this.labels[facKey]) {
        return this.labels[facKey]
      }
    }

    if (type === 'LABELS' || type == 'LABEL' || type === 'TASK_LABELS' || type === 'CONSULT_TIME') {
      let retLabel = this.labels && this.labels[value] ? this.labels[value] : (value && !returnNull ? value.split('_').join(' '): null);
      if (replace && type === 'CONSULT_TIME') {
        retLabel = retLabel.replace(`%ltr%`, replace.ltr);
        retLabel = retLabel.replace(`%rtr%`, replace.rtr);
      } else if (replace && Array.isArray(replace)) {
        replace.forEach(l => {
          const replacement = l.subtranslate
            ? (this.labels && this.labels[l.with] ? this.labels[l.with] : '')
            : l.with;
          retLabel = retLabel.replace(`%${l.key}%`, replacement)
        })
      } else if (replace) {
        Object.keys(replace).forEach(key => {
          retLabel = retLabel.replace(`%${key}%`, replace[key])
        })
      }
      return retLabel
    }
    if (type === 'LOCALE') {
      if(typeof value === 'string') {
        return value;
      }
      else if (!value || value.length == 0) {
        return defaultValue;
      }
      else {
        let temp = value.find(obj => {
          return obj.locale == this.user.currentLanguage;
        });
        if(temp){
          return temp[key];
        } else{
          return value[0][key];
        }
      }
    }
    if (type == 'FACNAME') {
      let facility = this.user.getFacilityByFacilityId(value);
      // console.log('facility<<>>', facility);
      if (facility) {
        let desc = facility.facilityName.find(k => { return k['locale'] == this.user.currentLanguage })
        if (!desc) desc = facility.facilityName[0];
        return desc.name
      } else {
        if (key) return key
        else return value
      }
    } 
    if (type === 'RELATION') {
      let val = this.relationList.find(obj => {
        return obj.code === value;
      })
      if (val) {
        let val1 = val['value'].find(obj => {
          return obj.locale == this.user.currentLanguage;
        })
        if (val1) {
          return val1['name'];
        } else {
          return val['value'][0]['name'];
        }
      } else {
        return value;
      }
    }
    if (type === 'MODEOFSERVICE') {
      let modeOfServices = this.checkModeOfService(value)
      return modeOfServices;
    }
    if (type == 'PACKAGEOBJ') {
      let allPackages = this.user.getAllDirectives()
      let concept = this.user.findConcept(allPackages, value)
      if (!concept) return fallback
      // console.log('PACKAGEOBJ', concept);
      return concept;
    } 
    if (type == 'LANG') {
      let obj = this.languageList.find(obj => {
        return obj.localeCode == value
      });
      return obj ? obj.localName : '';
    }
    if (type == 'TASKACTION') {
      let desckey = `TASKACTION_${value.code}`;
      console.log('TASKACTION', desckey);
      if (this.labels && this.labels[desckey]) {
        return this.labels[desckey]
      } else {
        return value['actionDescription'] || value['name']
      }
    }
    if (type == 'LANGARRAY') {
      if (!value) {
        return ''
      }
      if (value && !Array.isArray(value) && value.names) {
        value = value.names;
      }
      let temp = value.find(k => { return k['locale'] == this.user.currentLanguage })
      if (!temp) temp = value[0];
      if (temp && temp[key] && temp[key].trim()) {
        return temp[key];
      } else {
        return ''
      }
    }
  }

    private checkModeOfService(concept) {
    const packageIndicator = concept?.packageDtls?.pacakgeIndicator === 'PACKAGE' ? 'PACKAGE' : 'ORDERSET';
    if (packageIndicator == 'ORDERSET') {
      return concept._modeOfServices;
    } else {
      let allPackages = this.user.getAllDirectives();
      let servicesApplicable = concept?.packageDtls?.servicesApplicable
      let subservices = servicesApplicable.reduce((r, a) => {
        const subservice = this.user.findConcept(allPackages, a)
        if (subservice) r.push(subservice);
        return r;
      }, [])
      const modeOfServices = ['CLINIC'];
      let isHomeCareApplicable = subservices.every(s => s.packageDtls?.modeOfServices?.includes('HC'))
      if (isHomeCareApplicable) modeOfServices.push('HOMECARE')
      return modeOfServices;
    }
  }

}
